var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-select-component",
      class: { fullWidth: _vm.fullWidth, maxContent: _vm.maxContent },
    },
    [
      _c("div", { staticClass: "v-select-label" }, [
        _c(
          "div",
          { staticClass: "v-select-label-text-wrapper" },
          [
            _c("p", { staticClass: "v-select-label-text" }, [
              _vm._v(_vm._s(_vm.label)),
            ]),
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.explanation
                ? _c("div", { staticClass: "explanation-wrapper" }, [
                    _c("p", { staticClass: "explanation-text" }, [
                      _vm._v(_vm._s(_vm.explanation)),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "v-select-wrapper", class: { white: _vm.white } },
        [
          _c(
            "select",
            {
              staticClass: "v-select",
              attrs: { disabled: _vm.disabled },
              on: {
                input: function ($event) {
                  return _vm.$emit("input", $event.target.value)
                },
              },
            },
            _vm._l(_vm.options, function (option, i) {
              return _c(
                "option",
                {
                  key: i,
                  domProps: { value: option.value, selected: option.selected },
                },
                [_vm._v(_vm._s(option.title))]
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }